import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { lastValueFrom, Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ConfirmDialogService {

    private dialog = inject(MatDialog);

    async confirm(
        message: string,
        title?: string,
        confirmColor: 'primary' | 'warn' | 'accent' = 'primary',
        confirmMessage = 'Bestätigen',
        cancelMessage = 'Abbrechen',
    ): Promise<boolean | undefined> {
        return lastValueFrom(this.confirm$(
            message,
            title,
            confirmColor,
            confirmMessage,
            cancelMessage,
        ));
    }

    confirm$(
        message: string,
        title?: string,
        confirmColor: 'primary' | 'warn' | 'accent' = 'primary',
        confirmMessage = 'Bestätigen',
        cancelMessage = 'Abbrechen',
    ): Observable<boolean | undefined> {
        // of(null) needed so that dialog.open is called first, when the observer will be processed
        return of(null).pipe(
            switchMap(() => this.dialog.open(ConfirmDialogComponent, {
                data: {
                    message,
                    title,
                    confirmMessage,
                    confirmColor,
                    cancelMessage,
                },
            }).afterClosed(),
            ));
    }
}
